import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

const propostasService = {

    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/propostas`, { params });
        return response.data;
    },

    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas/${id}`);
        return response.data;
    },

    criar: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/propostas`, data);
        return response.data;
    },

    editar: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/propostas/${id}`, data);
        return response.data;
    },

    deletar: async (id) => {
        const response = await axiosInstance.delete(`${API_BASE}/propostas/${id}`);
        return response.data;
    },

    atualizarStatus: async (id, status) => {
        const response = await axiosInstance.put(`${API_BASE}/propostas/${id}/status`, { status });
        return response.data;
    },

    enviar: async (id, data) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas/${id}/enviar`, data);
        return response.data;
    },

    gerarPdf: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas/${id}/pdf`);
        return response.data;
    },

    duplicar: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas/${id}/duplicar`);
        return response.data;
    },

    novaVersao: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas/${id}/nova-versao`);
        return response.data;
    },

    versoes: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas/${id}/versoes`);
        return response.data;
    },

    eventos: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas/${id}/eventos`);
        return response.data;
    },

    relatorios: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/propostas/relatorios`, { params });
        return response.data;
    },

    variaveis: async () => {
        const response = await axiosInstance.get(`${API_BASE}/propostas/variaveis`);
        return response.data;
    },

    // `config` permite passar um AbortSignal: a geração pode levar até 2 minutos e
    // o modal de criação rápida oferece cancelar.
    gerarComIa: async (data, config = {}) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas/gerar-com-ia`, data, config);
        return response.data;
    },

    /**
     * Extrai mensagem legível do rejeite do axios (que devolve `response.data`).
     * Cobre erros da API (`message`) e o JSON genérico do Cloudflare (502/504).
     */
    mensagemErroGerarIa: (error, fallback = 'Não foi possível gerar a proposta com IA') => {
        if (!error) return fallback;
        if (typeof error === 'string' && error.trim()) return error.trim();
        if (typeof error.message === 'string' && error.message.trim()) return error.message.trim();
        // Cloudflare: origin 502/504 vira payload com cloudflare_error / detail em inglês.
        if (error.cloudflare_error || error.error_name === 'origin_bad_gateway') {
            return 'O serviço de IA está temporariamente indisponível. Aguarde um minuto e tente novamente.';
        }
        if (typeof error.detail === 'string' && error.detail.trim()) return error.detail.trim();
        if (typeof error.title === 'string' && error.title.trim()) return error.title.trim();
        return fallback;
    },

    listarTemplates: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas-templates`, { params: { cliente_id: clienteId } });
        return response.data;
    },

    buscarTemplate: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas-templates/${id}`);
        return response.data;
    },

    criarTemplate: async (data) => {
        const response = await axiosInstance.post(`${API_BASE}/propostas-templates`, data);
        return response.data;
    },

    editarTemplate: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/propostas-templates/${id}`, data);
        return response.data;
    },

    deletarTemplate: async (id) => {
        const response = await axiosInstance.delete(`${API_BASE}/propostas-templates/${id}`);
        return response.data;
    },

    uploadLogoTemplate: async (templateId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(
            `${API_BASE}/propostas-templates/${templateId}/logo`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    buscarConfig: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/propostas-config`, { params: { cliente_id: clienteId } });
        return response.data;
    },

    salvarConfig: async (data) => {
        const response = await axiosInstance.put(`${API_BASE}/propostas-config`, data);
        return response.data;
    }
};

export default propostasService;
